import type { Locale } from '@libs/core';

export const cityRequiredMsg = 'City is required';
export const streetAddressRequiredMsg = 'Street address is required';
export const zipCodeRequiredMsg = 'Zip code is required';
export const postalCodeRequiredMsg = 'Postal code is required';
export const zipCodeInvalidMsg = 'Enter a valid US zip code';
export const postalCodeInvalidMsg = 'Enter a valid CA postal code';
export const stateRequiredMsg = 'State is required';
export const provinceRequiredMsg = 'Province is required';
export const genericZipInvalidMsg = 'Enter a valid zip or postal code';

export const zipRequiredMessages: Record<Locale, string> = {
    'en-US': zipCodeRequiredMsg,
    'en-CA': postalCodeRequiredMsg,
};

export const zipInvalidMessages: Record<Locale, string> = {
    'en-US': zipCodeInvalidMsg,
    'en-CA': postalCodeInvalidMsg,
};

export const stateRequiredMessages: Record<Locale, string> = {
    'en-US': stateRequiredMsg,
    'en-CA': provinceRequiredMsg,
};
